<script>
export default {
  props: {
    socialProfiles: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      socialMediaLinks: [
        { key: 'facebook', icon: 'facebook', link: 'https://facebook.com/' },
        { key: 'twitter', icon: 'twitter', link: 'https://twitter.com/' },
        { key: 'linkedin', icon: 'linkedin', link: 'https://linkedin.com/' },
        { key: 'github', icon: 'github', link: 'https://github.com/' },
        { key: 'instagram', icon: 'instagram', link: 'https://instagram.com/' },
        { key: 'telegram', icon: 'telegram', link: 'https://t.me/' },
        { key: 'tiktok', icon: 'tiktok', link: 'https://tiktok.com/@' },
      ],
    };
  },
  computed: {
    availableProfiles() {
      return this.socialMediaLinks.filter(
        mediaLink => !!this.socialProfiles[mediaLink.key]
      );
    },
  },
};
</script>

<!-- eslint-disable-next-line vue/no-root-v-if -->
<template>
  <div v-if="availableProfiles.length" class="flex flex-col gap-2 w-full">
    <div
      v-for="profile in availableProfiles"
      :key="profile.key"
      class="w-full h-5 ltr:-ml-1 rtl:-mr-1"
    >
      <a
        :href="`${profile.link}${socialProfiles[profile.key]}`"
        target="_blank"
        rel="noopener noreferrer nofollow"
        class="flex items-center gap-2 text-n-slate-11 hover:underline"
      >
        <fluent-icon
          :icon="`brand-${profile.key}`"
          size="14"
          class="flex-shrink-0 ltr:ml-1 rtl:mr-1"
        />
        <span
          class="overflow-hidden text-sm whitespace-nowrap text-ellipsis"
          :title="`@${socialProfiles[profile.key]}`"
        >
          @{{ socialProfiles[profile.key] }}
        </span>
      </a>
    </div>
  </div>
</template>
